module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAIAAAAVyRqTAAAAKUlEQVRIx2NgUM3Eg/6fY8CDLgmY4EEMo0aPGj1q9KjRo0aPGj0UjQYAstmwZ9qYtCwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/td.png
// module id = 936
// module chunks = 0